import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import { MapPanelHeader, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";
import { MapEditorFeatureProperties } from "~/modules/mapEditor/components/MapEditorFeatureProperties";

import { useDeleteOtherFeatureMutation } from "./useDeleteOtherFeatureMutation";
import { useSuspenseOtherFeatureQuery } from "./useSuspenseOtherFeatureQuery";

export interface MapEditorFeatureOtherPanelContentProps {
    backHref: string;
    mapEditorFeatureId: string;
    readonly: boolean;
    title: string;
}

export function MapEditorFeatureOtherPanelContent({
    backHref,
    mapEditorFeatureId,
    readonly,
    title,
}: MapEditorFeatureOtherPanelContentProps) {
    const { t } = useTranslation("mapEditor");
    const navigate = useNavigate();

    const { data } = useSuspenseOtherFeatureQuery(mapEditorFeatureId);
    const [deleteAction, { loading: isDeleting }] = useDeleteOtherFeatureMutation();

    const mapFeature = data.mapEditorFeatureGetById;

    const handleDelete = async () => {
        await deleteAction(mapFeature.id);
        navigate(backHref, { relative: "path" });
    };

    return (
        <>
            <MapPanelHeader>
                <IconButton component={Link} color="inherit" relative="path" to={backHref}>
                    <ArrowBack />
                </IconButton>
                <Typography variant="h6" flex={1}>
                    {title}
                </Typography>
            </MapPanelHeader>
            <MapPanelScrollableArea>
                <Stack gap={2} padding={2}>
                    <Typography variant="h6">{t("mapEditorFeatureDetails.labelProperties")}</Typography>
                    <MapEditorFeatureProperties properties={mapFeature.properties} />
                    {!readonly && (
                        <Box sx={{ display: "flex", justifyContent: "center", padding: 2, opacity: isDeleting ? 0.5 : 1 }}>
                            <GaiaDeleteButton
                                label={t("MapEditorFeatureDetails.featureDelete.btnDelete")}
                                isLoading={isDeleting}
                                onDelete={handleDelete}
                                sx={{ flex: 1 }}
                            />
                        </Box>
                    )}
                </Stack>
            </MapPanelScrollableArea>
        </>
    );
}
